import React from 'react'
import { View } from 'react-native'

import PropTypes from 'prop-types'

import { VFText, Icon } from '@vfgroup-oneplatform/foundation/Components'
import { useTheme, getThemeImages } from '@vfgroup-oneplatform/foundation/Components/Themes'

import BookAppointmentButton from '../BookAppointmentButton'

import style from './NoAppointments.Styles'

const NoAppointments = ({ onBookAppointmentsButtonPress, isAdmin, currentTab }) => {
  const theme = useTheme()
  const Images = getThemeImages(theme.name)
  return (
    <View style={style.container}>
      <View style={style.contentContainer}>
        <Icon size={120} name={Images.icClock} />
        <VFText
          type={'primary'}
          style={style.title(theme)}
          i18nKey={currentTab === 1 ? 'your_appointments_no_appointment_title_previous' : 'your_appointments_no_appointment_title'}
        />
        <VFText
          type={'primary'}
          style={style.description(theme)}
          i18nKey={isAdmin ? 'your_appointments_no_appointment_subtitle_admin' : 'your_appointments_no_appointment_subtitle'}
        />
      </View>
      <BookAppointmentButton
        onBookAppointmentsButtonPress={onBookAppointmentsButtonPress}
        title='your_appointments_no_appointment_button_title'
      />
    </View>
  )
}

NoAppointments.propTypes = {
  onBookAppointmentsButtonPress: PropTypes.func,
  isAdmin: PropTypes.bool
}
export default NoAppointments
